var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ocean"},[_c('div',{staticClass:"img"},[_c('img',{attrs:{"src":"https://ym-attached-file.oss-cn-shanghai.aliyuncs.com/pcProject/marineServiceRoute.png"}})])])
}]

export { render, staticRenderFns }